<div class="incoming-bar" *ngIf="show">
  <div class="incoming-bar-info">
    <img [src]="getProfileImage(caller)" class="incoming-bar-avatar" />
    <div class="incoming-bar-text">
      <span class="incoming-bar-name">{{ caller?.name || 'Unknown' }}</span>
      <span class="incoming-bar-status">{{ phaseLabel }}</span>
    </div>
  </div>
  <div class="incoming-bar-actions">
    <button class="incoming-btn audio" (click)="accept(false)">
      <span class="material-symbols-outlined">mic</span> Audio
    </button>
    <button class="incoming-btn video" (click)="accept(true)">
      <span class="material-symbols-outlined">videocam</span> FaceTime
    </button>
    <button class="incoming-btn ptt" (click)="accept(false)">
      <span class="material-symbols-outlined">spatial_audio_off</span> PTT
    </button>
    <button class="incoming-btn decline" (click)="reject()">
      <span class="material-symbols-outlined">call_end</span> Decline
    </button>
  </div>
</div>